define('core/utils/collection/each',[
    'core/utils/object/has',
], function (
    has
) {
    'use strict';

    /*
     * Iterates over an object or a collection and calls a callback
     * function with each item as a parameter.
     */
    return function each(collection, callback) {
        var length = collection.length;
        var forEach = Array.prototype.forEach;

        if (isNaN(length)) {
            // Treat collection as an object
            for (var key in collection) {
                if (has(collection, key))
                    callback(collection[key], key, collection);
            }
        } else if (forEach) {
            // Treat collection as an array
            forEach.call(collection, callback);
        } else {
            for (var i = 0; i < length; i++)
                callback(collection[i], i, collection);
        }
    };
});

